/**
 * Created On : 22nd Feb 2018
 * Usage : Display get data div on click event of trend chart 
 * Coprights : Johnson Controls India Pvt Ltd.
 **/
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalController, NavParams } from 'ionic-angular';
import { PointService } from '../../services/point.service';
import { PointClick } from '../../models/point-click.model';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'get-data',
    templateUrl: 'get-data.html'
})
export class GetDataComponent {  
    public pointClicked: PointClick; 
    @Output() closeDiv = new EventEmitter();
    @Output() showPoints = new EventEmitter();
    constructor(
        private pointService: PointService,
        public datepipe: DatePipe


    ) {
        this.pointClicked = this.pointService.getPointClicked();
    }
    ngOnInit(){
    }
  
    closeDivFn(){
        this.closeDiv.emit(this);
    }

    getDataFn(){
        this.showPoints.emit(true);
    }
}



// WEBPACK FOOTER //
// ./src/components/get-data/get-data.ts